import React from 'react';
import { ResponsiveContainer, LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Legend } from 'recharts';
import { CHART_COLORS } from '../constants';
import PropTypes from 'prop-types';

const WeeklyPerformanceChart = ({ data }) => {
    if (!data) return null;

    return (
        <div className="chart-container weekly-performance-chart">
            <h3>Weekly Performance</h3>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={data}>
                    <CartesianGrid
                        strokeDasharray="3 3"
                        stroke={CHART_COLORS.grid}
                    />
                    <XAxis
                        dataKey="week_label"
                        stroke={CHART_COLORS.text}
                        angle={-45}
                        textAnchor="end"
                        height={60}
                        interval={0}
                        tick={{ fontSize: 11 }}
                    />
                    <YAxis stroke={CHART_COLORS.text} />
                    <Tooltip
                        content={({ active, payload, label }) => {
                            if (active && payload && payload.length) {
                                const data = payload[0].payload;

                                // Don't show tooltip for weeks with no data
                                if (data.total_picks === 0) {
                                    return (
                                        <div style={{
                                            backgroundColor: CHART_COLORS.background,
                                            border: `1px solid ${CHART_COLORS.grid}`,
                                            color: CHART_COLORS.text,
                                            padding: '10px',
                                            borderRadius: '4px'
                                        }}>
                                            <div style={{ marginBottom: '5px', fontWeight: 'bold' }}>
                                                {label}: No games completed
                                            </div>
                                        </div>
                                    );
                                }

                                return (
                                    <div style={{
                                        backgroundColor: CHART_COLORS.background,
                                        border: `1px solid ${CHART_COLORS.grid}`,
                                        color: CHART_COLORS.text,
                                        padding: '12px',
                                        borderRadius: '4px',
                                        minWidth: '200px'
                                    }}>
                                        <div style={{ marginBottom: '8px', fontWeight: 'bold', fontSize: '14px' }}>
                                            {label} Summary
                                        </div>

                                        <div style={{ marginBottom: '8px', fontSize: '13px' }}>
                                            <strong>{data.total_picks} picks:</strong> {data.wins} wins, {data.losses} losses ({data.win_rate}% win rate)
                                        </div>

                                        <div style={{ fontSize: '12px', color: '#ccc' }}>
                                            <div>Avg margin: {data.avg_margin > 0 ? '+' : ''}{Math.round(data.avg_margin * 10) / 10}</div>
                                            <div>Best: {data.best_margin > 0 ? '+' : ''}{Math.round(data.best_margin * 10) / 10}</div>
                                            <div>Worst: {data.worst_margin > 0 ? '+' : ''}{Math.round(data.worst_margin * 10) / 10}</div>
                                        </div>
                                    </div>
                                );
                            }
                            return null;
                        }}
                    />
                    <Legend />
                    <Line
                        type="monotone"
                        dataKey="avg_margin"
                        stroke={CHART_COLORS.primary}
                        name="Avg Margin"
                    />
                    <Line
                        type="monotone"
                        dataKey="wins"
                        stroke={CHART_COLORS.secondary}
                        name="Wins"
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

WeeklyPerformanceChart.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        week_number: PropTypes.number.isRequired,
        week_label: PropTypes.string.isRequired,
        avg_margin: PropTypes.number.isRequired,
        wins: PropTypes.number.isRequired,
        losses: PropTypes.number.isRequired,
        total_picks: PropTypes.number.isRequired,
        win_rate: PropTypes.number.isRequired,
        best_margin: PropTypes.number.isRequired,
        worst_margin: PropTypes.number.isRequired
    })).isRequired
};

export default WeeklyPerformanceChart;
